import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ILookupResponse } from '../../../../model/apm/base/lookup-response';
import { IPortalDocumentResponse } from '../../../../model/apm/document/portal-document-response';
import { IPurchaseContractPagedRequest } from '../../../../model/apm/purchase-contract/request/purchase-contract-paged-request';
import { IPurchaseContractAddEditRequest } from '../../../../model/apm/purchase-contract/request/purchase-contract-add-edit-request';
import { IPurchaseContractListResponse } from '../../../../model/apm/purchase-contract/response/purchase-contract-list-response';
import { IPurchaseContractResponse } from '../../../../model/apm/purchase-contract/response/purchase-contract-response';

const defaultPath = 'PurchaseContract';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IPurchaseContractPagedRequest): Promise<Pagination<IPurchaseContractListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            IsCovid19: params.isCovid19,
            Year: params.year,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IPurchaseContractListResponse>(), response.data));
};

const getById = async (id: number): Promise<IPurchaseContractResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IPurchaseContractAddEditRequest): Promise<IPurchaseContractResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IPurchaseContractAddEditRequest): Promise<IPurchaseContractResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const listDocumentTypes = async (): Promise<ILookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentType`
    }).then((response) => response.data || []);
};

// O Content-Type multipart (com boundary) é definido pelo axios a partir do FormData
const uploadFile = async (id: number, documentTypeId: number, file: File, onProgress?: (percent: number) => void): Promise<IPortalDocumentResponse> => {
    const formData = new FormData();
    formData.append('DocumentTypeId', String(documentTypeId));
    formData.append('File', file);

    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${id}/File`,
        data: formData,
        onUploadProgress: (event) => {
            if (onProgress && event.total) {
                onProgress(Math.round((event.loaded * 100) / event.total));
            }
        }
    }).then((response) => response.data);
};

const removeFile = async (id: number, fileId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/File/${fileId}`
    });
};

const PurchaseContractAppService = {
    list, getById, add, edit, remove,
    listDocumentTypes, uploadFile, removeFile
};
export default PurchaseContractAppService;
